<div class="tw-bg-gray-100 dark:tw-bg-gray-900 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[256px_1fr]">
  <app-organization-settings-sidebar></app-organization-settings-sidebar>
  <app-organization-settings-content></app-organization-settings-content>
</div>
